import { tr } from '../lib/tankRoleText';
import { isSource } from '../lib/aquaNet';

const N = ({ id, l, v, on, u, ph, step = '0.1' }) => <label>{l}<input type="number" step={step} data-testid={id} placeholder={ph} value={v ?? ''} onChange={(e) => on(e.target.value)} /> {u}</label>;

// pump: 1- or 3-point curve, speed, flow direction and control (always on / off / tank level / clock time)
export function AquaPump({ t, h, set, project }) {
  const c = h.ctl || { mode: 'on' }, setC = (p) => set({ ctl: { ...c, ...p } });
  const tanks = (project?.fittings || []).filter((f) => isSource(f) && f.hyd?.mode === 'tank');
  return (
    <>
      <N id="aq-pump-q1" l={t.aqPumpQ} v={h.q1} on={(v) => set({ q1: v })} u="l/s" ph="10" />
      <N id="aq-pump-h1" l={t.aqPumpH} v={h.h1} on={(v) => set({ h1: v })} u="m" ph="40" />
      <N id="aq-pump-h0" l={t.aqPumpH0} v={h.h0} on={(v) => set({ h0: v })} u="m" />
      <N id="aq-pump-q2" l={t.aqPumpQ2} v={h.q2} on={(v) => set({ q2: v })} u="l/s" />
      <N id="aq-pump-h2" l={t.aqPumpH2} v={h.h2} on={(v) => set({ h2: v })} u="m" />
      <N id="aq-pump-speed" l={t.aqPumpSpeed} v={h.speed} on={(v) => set({ speed: v })} ph="1" step="0.05" />
      <N id="aq-pump-eff" l={tr().eff} v={h.eff} on={(v) => set({ eff: v })} u="%" ph="65" step="1" />
      <label className="aq-inline"><input type="checkbox" data-testid="aq-pump-rev" checked={!!h.rev} onChange={(e) => set({ rev: e.target.checked })} /> {t.aqPumpRev}</label>
      <small className="muted aq-span">{t.aqPumpCurveHint}</small>
      <label>{t.aqPumpCtl}<select data-testid="aq-pump-ctl" value={c.mode} onChange={(e) => setC({ mode: e.target.value })}>
        {['on', 'off', 'level', 'time'].map((m) => <option key={m} value={m}>{t[`aqCtl_${m}`]}</option>)}
      </select></label>
      {c.mode === 'level' && <>
        <label>{t.aqCtlTank}<select data-testid="aq-pump-tank" value={c.tank || ''} onChange={(e) => setC({ tank: e.target.value })}><option value="">–</option>{tanks.map((f) => <option key={f.id} value={f.id}>{f.name || f.id}</option>)}</select></label>
        <N id="aq-pump-lon" l={t.aqCtlOn} v={c.on} on={(v) => setC({ on: v })} u="m" />
        <N id="aq-pump-loff" l={t.aqCtlOff} v={c.off} on={(v) => setC({ off: v })} u="m" />
      </>}
      {c.mode === 'time' && <>
        <label>{t.aqCtlTOn}<input type="time" data-testid="aq-pump-ton" value={c.ton || ''} onChange={(e) => setC({ ton: e.target.value })} /></label>
        <label>{t.aqCtlTOff}<input type="time" data-testid="aq-pump-toff" value={c.toff || ''} onChange={(e) => setC({ toff: e.target.value })} /></label>
      </>}
    </>
  );
}
